import axios from 'axios';
import { v4 as uuid } from 'uuid';

let requestId: string | null = null;

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true // needed for refreshToken cookie
});

// Capture request ID from server responses
axiosClient.interceptors.response.use(
  (response) => {
    const id = response.headers['x-request-id'];
    if (id) requestId = id;
    return response;
  },
  (error) => {
    const id = error.response?.headers?.['x-request-id'];
    if (id) requestId = id;
    return Promise.reject(error);
  }
);

axiosClient.interceptors.request.use((config) => {
  requestId = uuid();

  if (config.headers) {
    config.headers.set('x-request-id', requestId);
  }

  return config;
});

export default axiosClient;
